// @ts-nocheck

import React, { useCallback } from 'react';
import type { FormikHelpers, FormikProps } from 'formik';
import type { ReactNode } from 'react';

import { Form } from '../../../index';
import PageFooter from './PageFooter';
import { CardWrapper } from './CardPage';

// Пропсы формы справочников
export type CommonFormProps<T> = {
  // Метод отправки измененных данных
  onSubmit?: (values: T) => void | Promise<void>;
  // Метод отмены изменения данных
  onCancel?: (values: T) => void | Promise<void>;
  // данные
  data: T;
  //
  children?: (props: FormikProps<T>) => ReactNode;
  // использовать футер
  useFooter?: boolean;
  disableSubmitButton?: (values: T) => boolean;
  noWrapMe?: boolean;
};

type FormChildProps = {
  children?: ReactNode;
  noWrapMe?: boolean;
};

export default function CommonForm<T>({
  onSubmit,
  onCancel,
  data,
  children,
  useFooter,
  disableSubmitButton,
}: CommonFormProps<T>) {
  /**
   *  Обертка для children. Обертывает каждый элемент в "карточки"
   *  В случае, если встречает объект со свойством noWrapMe, то не оборачивает его
   */
  const Content = useCallback(
    (formikProps: FormikProps<T>) => {
      const formContent = children?.(formikProps);
      const formElement = React.isValidElement<FormChildProps>(formContent)
        ? formContent
        : null;
      const content =
        React.Children.map(
          formElement
            ? formElement.props.children
            : formContent,
          (child, index) => {
            if (
              React.isValidElement<FormChildProps>(child) &&
              child.props.noWrapMe
            ) {
              return child;
            }
            return <CardWrapper key={index}>{child || null}</CardWrapper>;
          }
        ) ?? [];

      if (useFooter) {
        content.push(
          // 99999, так как маловероятно, что будет такое количество элементов
          <CardWrapper key={99999}>
            <PageFooter<T>
              disableSubmitButton={disableSubmitButton}
              {...formikProps}
              onCancel={onCancel}
            />
          </CardWrapper>
        );
      }
      return content;
    },
    [children, disableSubmitButton, onCancel, useFooter]
  );

  const handleSubmit = async (
    values: T,
    _formikHelpers: FormikHelpers<T>
  ) => {
    await onSubmit?.(values);
  };

  return (
    <Form initialValues={data} onSubmit={handleSubmit}>
      {(_FormField, formikProps: FormikProps<T>) => (
        <form onSubmit={formikProps.handleSubmit}>
          <Content {...formikProps} />
        </form>
      )}
    </Form>
  );
}
